import { render, staticRenderFns } from "./secondary-fee.vue?vue&type=template&id=5e905df9&scoped=true&"
import script from "./secondary-fee.vue?vue&type=script&lang=js&"
export * from "./secondary-fee.vue?vue&type=script&lang=js&"
import style0 from "./secondary-fee.vue?vue&type=style&index=0&id=5e905df9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e905df9",
  null
  
)

export default component.exports